// Module
var code = "<div class=\"form-group\">\n  <label for=\"target_node\" class=\"col-sm-1 control-label text-left\">Node</label>\n  <div class=\"col-sm-11\">\n    <select class=\"form-control\" ng-model=\"$ctrl.model\" ng-options=\"agent.NodeName as agent.NodeName for agent in $ctrl.agents\" data-cy=\"target-node-c\"></select>\n  </div>\n</div>\n";
// Exports
var _module_exports = code;;
var path = 'app/agent/components/node-selector/nodeSelector.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;